import { render } from "./ValueOverviewAdmin.vue?vue&type=template&id=0b7e4c78"
import script from "./ValueOverviewAdmin.vue?vue&type=script&lang=js"
export * from "./ValueOverviewAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__